import './naturalhistory/style';
import FormStructure from './naturalhistory/form_structure';

export default FormStructure;